<article class="program-sub-domain-container">
  <div class="program-sub-domain">
    <app-programs-details-side-menu
      [selectedProgram]="selectedProgram!"
    ></app-programs-details-side-menu>

    <div class="sub-domain"><router-outlet></router-outlet></div>
  </div>
</article>
